import { useQuery } from '@apollo/client';
import React, { useEffect } from 'react';
import Loading from '../Common/Loading/Loading';
import { ERROR_MESSAGE, LoadingButton } from '../Messages/Messages';
import { LEGAL_POLICY_QUERY } from './operations';
import LegalPolicyLeftNavContainer from './LegalPolicyLeftNavContainer';
import { TmntHtml, TmntText } from '../Common/Text';

export default function LegalPolicyBlock() {
  const [textKey, setTextKey] = React.useState('');

  useEffect(() => {
    const params = new URLSearchParams(window?.location?.search);
    const textKeyParam = params.get('textKey') || 'aboutUsLink';
    setTextKey(textKeyParam);
  }, []);

  const { loading, error, data } = useQuery(LEGAL_POLICY_QUERY, {
    variables: {
      key: textKey,
    },
    skip: !textKey, // Skip the query if textKey is not defined
    ssr: false,
    context: { batch: true },
  });

  if (error) return ERROR_MESSAGE;

  return (
    <Loading isLoading={loading}>
      <div className="legal-policy-block" data-testid="legal-policy-block">

        <div className="legal-policy-content">
          <div className="legal-policy-nav-container">
            <div className="legal-policy-header div">
              <TmntText tmnt={data?.textFor?.customerHelp} />
            </div>
            <LegalPolicyLeftNavContainer navData={data?.legalPolicy?.allData} textKey={textKey} />
          </div>
          <div className="legal-policy-text-container">
            {loading ? (
              <span data-testid="legal-modal-spinner" className="legal-modal-spinner">
                <LoadingButton showText={false} />
              </span>
            ) : (
              <TmntHtml tmnt={data?.textFor?.legalContent} />
            )}
          </div>
        </div>
      </div>
    </Loading>
  );
}
